export const KEY = {
	ARROW_DOWN: "ArrowDown",
	ARROW_UP: "ArrowUp",
	ENTER: "Enter",
	SPACE: " ",
};
